import { Component, Inject, OnDestroy, OnInit, Optional, HostListener } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { EventMessageComponent, WsService } from '../../shared/index';
import { OrderService } from '@app/shared/services/order.service';

@Component({
  selector: 'app-order-form-delete',
  templateUrl: './order-form-delete.component.html',
  styleUrls: ['./order-form-delete.component.scss']
})
export class OrderFormDeleteComponent implements OnInit, OnDestroy {

  reason = null;
  comment = null;
  req_del = null;
  ws$: Subscription;
  in_progress = false;
  err = {
    status: false,
    msg: null
  };
  reasons = [];
  isDisabled: boolean;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<OrderFormDeleteComponent>,
    private ws: WsService,
    private orderService: OrderService,
    private snackBar: MatSnackBar) {
    const carBreackingReason = data.reason.find(el => el.display_name == 'Машина не найдена');
    this.reasons = data.reason;
    const index = data.reason.indexOf(carBreackingReason);
    if (index != -1) {
      this.reasons.splice(index, 1);
      this.reasons.unshift(carBreackingReason);
    }    
    if (!data.reason.length) {
      this.isDisabled = true;
      this.handleServiceEvent('Нет причин для удаления заказа!');
      this.comment = 'Нет причин для удаления заказа!';
    } else {
      this.isDisabled = false;
      this.reason = data.reason[0].id;
    } 
    
  }

  ngOnInit() {
    this.ws$ = this.ws.message.subscribe(data => {
      let res = JSON.parse(data);
      if (this.req_del == res.header.data_id && res.header.data_id !== undefined) {
        if (res.header.status.toLowerCase() == 'ok') {
          this.handleServiceEvent('Заказ удален');
          this.dialogRef.close();
        } else {
          this.err = {
            status: true,
            msg: res.data.message
          };
          setTimeout(() => {
            this.err = {
              status: false,
              msg: null
            };
            this.in_progress = false;
          }, 3000);

        }
      }

    });
  }

  ngOnDestroy() {
    this.ws$.unsubscribe();
  }

  @HostListener('keyup.F9')
  @HostListener('keypress.Enter')
  send() {
    if (this.reason == null) {
      this.handleServiceEvent('Вы не выбрали причинy');
      return;
    }

    this.req_del = 'rd' + new Date();
    this.in_progress = true;
    this.orderService.cancelOrder({
      'id': this.data.id,
      'reason': this.reason,
      'comment': this.comment
    }).subscribe({
      next: () => {
        this.handleServiceEvent('Заказ отменен успешно')
        this.dialogRef.close();
      },
      error: err => {
        console.dir(err);
        this.dialogRef.close();
      }
    });    

    // this.ws.send( {
    //   'header': {
    //     'type': 'req',
    //     'action': 'cancel',
    //     'data_id': this.req_del
    //   },
    //   'data': {
    //     'id': this.data.id,
    //     'reason': this.reason,
    //     'comment': this.comment
    //   }
    // } );
  }

  @HostListener('keyup.Escape')
    onkeyup(){
      this.dialogRef.close();
    }

  private handleServiceEvent(msg) {
    this.snackBar.openFromComponent(EventMessageComponent, <MatSnackBarConfig>{
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      data: {
        'message': msg
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/order-form-delete/order-form-delete.component.ts